import constants from 'utils/addresses/constants';

const buildAddressValue = (addressParserParams) => {
  let address = '';
  const ADDRESS_FIELDS_ORDER_IN_ORDER = constants.ADDRESS_FIELDS_ORDER_IN_ORDER;
  ADDRESS_FIELDS_ORDER_IN_ORDER.forEach((field) => {
    const param = addressParserParams.find((pair) => pair.label === field);
    if (param) {
      address = `${address} ${param.value}`;
    }
  });

  return address.trim();
};

const getPOIServiceParamsFromAddressParserResponse = (
  addressParserResponse
) => {
  const PARAMS_MAP = constants.POI_PARSER_PARAMS_TO_PELIAS_PARAMS;
  const ADDRESS_FIELD = 'address';
  let params = {};
  const addressParserParams = addressParserResponse || [];
  addressParserParams.forEach((pair) => {
    const parserParamKey = PARAMS_MAP[pair.label];
    params[parserParamKey] = pair.value;
  });

  const address = buildAddressValue(addressParserParams);
  if (address) {
    params[ADDRESS_FIELD] = address;
  }

  return params;
};

export default getPOIServiceParamsFromAddressParserResponse;
